
/**
 * Utility functions for determining recipe types
 */

/**
 * Analyzes the title and ingredients to determine the recipe type
 */
export const determineRecipeType = (title: string = '', ingredients: string[]): string => {
  const lowerTitle = title.toLowerCase();
  const lowerIngredients = ingredients.map(i => i.toLowerCase());
  
  // Check for main dish indicators (protein sources)
  if (lowerIngredients.some(i => 
    i.includes('chicken') || 
    i.includes('beef') || 
    i.includes('fish') || 
    i.includes('pork') || 
    i.includes('tofu')
  )) {
    return 'main_dish';
  }
  
  // Check for pasta dishes
  if (lowerTitle.includes('pasta') || 
      lowerTitle.includes('spaghetti') || 
      lowerIngredients.some(i => i.includes('pasta') || i.includes('noodle'))) {
    return 'pasta';
  }
  
  // Check for soup/stew
  if (lowerTitle.includes('soup') || 
      lowerTitle.includes('stew') || 
      lowerIngredients.some(i => i.includes('broth') || i.includes('stock'))) {
    return 'soup';
  }
  
  if (lowerTitle.includes('tortilla') || lowerIngredients.some(i => i.includes('tortilla'))) {
    return 'tortilla';
  }
  
  if (lowerTitle.includes('bread') || lowerIngredients.some(i => i.includes('yeast'))) {
    return 'bread';
  }
  
  if (lowerTitle.includes('cake') || lowerIngredients.some(i => i.includes('flour') && i.includes('sugar'))) {
    return 'cake';
  }
  
  if (lowerTitle.includes('cookie') || lowerIngredients.some(i => i.includes('chocolate chip'))) {
    return 'cookie';
  }
  
  return 'general';
};
